import { api, apiFormData } from './api';

export interface Influencer {
  id?: number;
  name: string;
  slug: string;
  description?: string;
  summary?: string;
  image?: string;
  cover?: string;
  meta_title?: string;
  meta_description?: string;
  active?: boolean;
  order?: number;
  products_count?: number;
  created_at?: string;
  updated_at?: string;
}

export const influencerService = {
  getInfluencers: async (page = 1, params?: { search?: string; active?: boolean; per_page?: number }) => {
    const query = new URLSearchParams({ page: String(page), per_page: String(params?.per_page || 15) });
    if (params?.search) query.append('search', params.search);
    if (params?.active !== undefined) query.append('active', String(params.active));
    const response = await api.get(`/api/admin/influencers?${query.toString()}`);
    return response.data;
  },

  getInfluencerById: async (id: number | string) => {
    const response = await api.get(`/api/admin/influencers/${id}`);
    return response.data;
  },

  createInfluencer: async (data: Partial<Influencer>) => {
    const response = await api.post('/api/admin/influencers', data);
    return response.data;
  },

  updateInfluencer: async (id: number | string, data: Partial<Influencer>) => {
    const response = await api.put(`/api/admin/influencers/${id}`, data);
    return response.data;
  },

  deleteInfluencer: async (id: number | string) => {
    const response = await api.delete(`/api/admin/influencers/${id}`);
    return response.data;
  },

  toggleInfluencer: async (id: number | string) => {
    const response = await api.post(`/api/admin/influencers/${id}/toggle`);
    return response.data;
  },

  uploadImage: async (file: File, folder = 'influencers') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);

    const response = await apiFormData.post('/api/admin/upload/send', formData);
    return response.data;
  },
};
